module.exports = __webpack_public_path__ + "static/media/Addiction_Stakeholders_Survey.bfa2366a.pdf";